import HomeView from "@/pages/HomeView";
import BugoJangView from "@/pages/BugoJangView";
import WriteBugoJangView from "@/pages/WriteBugoJangView";
import KakaoLoginLendingView from "@/pages/KakaoLoginLendingView";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/bugojang',
    name: 'bugoJang',
    component: BugoJangView,
  },
  {
    path: '/bugojang/write',
    name: 'writeBugoJangView',
    component: WriteBugoJangView,
  },
  {
    path: '/kakao-login-lending',
    name: 'kakaoLoginLendingView',
    component: KakaoLoginLendingView,
  },
];

export const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes, // short for routes: routes
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})